import React from "react";

import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import { Auth } from "aws-amplify";
import { Authentication } from "../context/AuthenticationContext";

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: "flex"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  title: {
    flexGrow: 1,
    marginLeft: 20
  }
});

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      code: "",
      submitting: false
    };
  }

  handleChange = e => {
    this.setState({
      code: e.target.value
    });
  };

  verifyEmail = async () => {
    try {
      this.setState({ submitting: true });
      await Auth.verifyCurrentUserAttributeSubmit("email", this.state.code);
      this.props.history.push("/");
      console.log("verified!");
    } catch (err) {
      this.setState({ submitting: true });
    }
  };

  resendVerificationCode = async () => {
    await Auth.verifyCurrentUserAttribute("email");
  };

  signOut = async () => {
    try {
      await Auth.signOut();
      this.props.history.push("/");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <Grid container direction="row" justify="center" alignItems="center" spacing={40}>
          <AppBar position="absolute" className={classNames(classes.appBar)}>
            <Toolbar disableGutters={!this.state.open} className={classes.toolbar}>
              <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                DentistFind
              </Typography>
              <Button color="inherit" onClick={this.signOut}>
                Logout
              </Button>
            </Toolbar>
          </AppBar>

          <Grid item xs={12} sm={10} md={7}>
            <Paper style={{ marginTop: 100, padding: 20 }}>
              <Typography variant="h4" gutterBottom style={{ textAlign: "center" }}>
                Enter verification code.
              </Typography>

              <TextField
                label="New Password"
                margin="normal"
                style={{ width: "100%", fontSize: "80px" }}
                variant="outlined"
                onChange={this.handleChange}
              />

              <Button variant="contained" color="primary" onClick={this.verifyEmail} disabled={this.state.submitting}>
                Submit {this.state.submitting && <CircularProgress size={12} color="primary" style={{ marginLeft: 5 }} />}
              </Button>
              <Button variant="contained" color="primary" onClick={this.resendVerificationCode} style={{ marginLeft: 10 }}>
                Resend Verification
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </>
    );
  }
}

let VerifyEmailWithStyles = withStyles(styles)(VerifyEmail);

export default function ConsumerWrapper(props) {
  return (
    <Authentication.Consumer>
      {context => {
        return <VerifyEmailWithStyles context={context} {...props} />;
      }}
    </Authentication.Consumer>
  );
}
